import { createSlice } from '@reduxjs/toolkit';
import { reportsTexts } from 'locale/es';
import { toast } from './notificationReducer';
import ScoreService from 'services/ScoreService';

const initialState = { data: [], loading: false, error: null };

const scoresByPatientSlice = createSlice({
  name: 'scoresByPatient',
  initialState,
  reducers: {
    setScores(state, action) {
      const { data } = action.payload;
      return { ...state, data, loading: false, error: null };
    },
    setScoresLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setScoresError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetScoresByPatient(state, action) {
      return initialState;
    },
  },
});

export const {
  setScores,
  setScoresLoading,
  setScoresError,
  resetScoresByPatient,
} = scoresByPatientSlice.actions;

export const initializeScoresByPatient = (patientId) => {
  return async (dispatch) => {
    try {
      dispatch(setScoresLoading());

      const { data } = await ScoreService.getAllByPatient(patientId);
      dispatch(setScores({ data }));
    } catch (error) {
      console.error(error);
      dispatch(
        setScores({ message: error.message, status: error.response?.status })
      );
      dispatch(toast(reportsTexts.LOADING_ERROR, 'error'));
    }
  };
};

export default scoresByPatientSlice.reducer;
